import { array, object } from 'prop-types'
import React from 'react'

import { isEmpty } from '../../../external/utilities/GeneralUtils'
import HackHTag from '../../shared/text/HackHTag'

const FacilityAmenities = ({ amenities }) => {
  if (isEmpty(amenities)) {
    return <i></i>
  }

  const categorized = {}
  const sectionNames = {}

  amenities.forEach((amenity) => {
    if (!categorized[amenity.distanceCode]) {
      categorized[amenity.distanceCode] = []
      sectionNames[amenity.distanceCode] = amenity.distanceName
    }
    categorized[amenity.distanceCode].push(amenity)
  })

  const amenitySections = Object.keys(categorized).map((key) => {
    const sectionValues = categorized[key]
    let left
    let right
    if (sectionValues.length > 0) {
      const midPoint = Math.ceil(sectionValues.length / 2)
      left = sectionValues.slice(0, midPoint) // ["a", "b"]
      right = sectionValues.slice(midPoint) // ["d", "e", "f"]
    }

    return (
      <div key={key} className="amenity-section">
        <HackHTag h3>{sectionNames[key]}</HackHTag>
        <div className="full-bleed col-md-6">
          {left.map((amenity, key) => (
            <div key={key}>{amenity.name}</div>
          ))}
        </div>
        <div className="full-bleed col-md-6">
          {right.map((amenity, key) => (
            <div key={key}>{amenity.name}</div>
          ))}
        </div>
        <div className="clearfix"></div>
      </div>
    )
  })

  return <div className="note">{amenitySections}</div>
}

FacilityAmenities.propTypes = {
  intl: object.isRequired,
  amenities: array,
}

export default FacilityAmenities
